// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"editURL_wrapper__3hRv-","buttons":"editURL_buttons__3vLuq"};